<template>
  <div class="main energyMain">
    <!-- 顶部 -->
    <div class="top" style="justify-content: space-between;">
      <div style="display: flex;align-items: center;">
        <img class="goback" src="../assets/back.png" @click="goback" />
        <span>返回</span>
      </div>
      <div>能耗及相关数据文件上传<span style="font-size: 16px;">（铂金项目必传）</span></div>
      <el-button type="primary" @click="next" size="small">下一步</el-button>
    </div>
    <div class="fileAbout">
      <!-- 类别 -->
      <el-select v-model="category" clearable placeholder="请选择文件类别">
        <el-option
          v-for="item in categoryOptions"
          :key="item"
          :label="item"
          :value="item">
        </el-option>
      </el-select>
      <!-- 选取文件 -->
      <el-button type="primary" size="medium" plain @click="uploadFile" class="selectFile">选取文件</el-button>
      <input ref="upload" type="file" style="display: none;" @change="handleChange" />
      <!-- 文件名 -->
      <a
        v-if="file_path"
        :href="file_path"
        target="_blank"
        class="fileName"
      >{{file_name}}</a>
      <!-- 上传按钮 -->
      <el-button type="success" size="medium" @click="sure" class="sureBtn el-icon-upload">上传</el-button>
    </div>
    <!-- 表格部分 -->
    <el-table :data="tableData" height="500" border stripe style="width:99%;">
      <el-table-column type="index" :index="increamentIndex" label="序号" align="center" width="100"></el-table-column>
      <el-table-column prop="category" label="类别" align="center"></el-table-column>
      <el-table-column prop="file_name" label="文件名" align="center"></el-table-column>
      <el-table-column prop="file_time" label="上传时间" align="center"></el-table-column>
      <el-table-column label="操作" align="center" width="180">
        <template slot-scope="scope">
          <el-button type="primary" size="small" @click="downloadFile(scope.row)">下载</el-button>
          <el-button type="danger" size="small" @click="delFile(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
  </div>
</template>

<script>
import * as API from '../utils/apiService'
import { getFileURL } from '../utils/utils'
import config from '../config'

const { downloadUrl } = config
export default {
  data () {
    return {
      getFileURL,
      downloadUrl,
      category: '',
      categoryOptions: [
        '水',
        '电',
        '燃气',
        '燃油',
        '外供热源',
        '外供冷源',
        '可再生能源',
        '污染物浓度',
        '隔声性能',
        '其他'
      ],
      file: null,
      file_path: '',
      file_name: '',
      tableData: [], // 所有数据带分页
      categoryList: [], // 所有数据不带分页
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },

  mounted () {
    this.asyncGetFileList()
  },

  methods: {
    // 序号自增
    increamentIndex (index) {
      return index + (this.currentPage - 1) * this.pageSize + 1
    },

    goback () {
      this.$router.go(-1)
    },

    uploadFile () {
      this.$refs.upload.click()
    },

    handleChange (e) {
      let file = e.target.files[0]
      this.file = file
      this.file_name = file.name
      this.file_path = this.getFileURL(file)
      // 上传之后清空
      this.$refs.upload.value = ''
    },

    asyncGetFileList () {
      let params = {
        project_id: this.$route.query.id,
        file_type: '1',
        currentPage: this.currentPage,
        pageSize: this.pageSize
      }
      API.getFileList(params).then(resp => {
        if (resp.resultCode === '0000') {
          this.tableData = resp.data.fileList.list
          this.total = resp.data.fileList.total
          this.categoryList = resp.data.categoryList
        }
      })
    },

    sure () {
      if (!this.category) {
        this.$message.error('请选择文件类别！')
        return
      }
      if (!this.file_path) {
        this.$message.error('请选择文件')
        return
      }
      let params = {
        project_id: this.$route.query.id,
        file: this.file,
        file_type: '1',
        category: this.category
      }
      API.addFileInfo(params).then(resp => {
        if (resp.resultCode === '0000') {
          this.$message.success(resp.resultMsg)
          this.asyncGetFileList()
          this.category = ''
          this.file_name = ''
        }
      })
    },

    next () {
      if (this.$route.query.isPt === 'true') {
        if (this.tableData.length === 0) {
          this.$message.error('请上传用能数据文件！')
          return
        }
        // 判断是否所以类别都上传文件
        let isAll = this.categoryOptions.filter(i_ => i_ !== '其他').every(item => {
          const isIncludes = this.categoryList.map(i => i.category).includes(item)
          if (!isIncludes) this.$message.error(`请上传全部类别数据！`)
          return isIncludes
        })

        if (isAll) {
          if (this.$route.query.isUpdateInfo === 'true') {
            this.$router.push('/technologyList?isUpdateInfo=true&id=' + this.$route.query.id)
          } else if (this.$route.query.isSubmitted === 'true') {
            this.$router.push('/technologyList?isSubmitted=true&id=' + this.$route.query.id)
          }
        }
      } else {
        if (this.$route.query.isSubmitted === 'true') {
          this.$router.push('/technologyList?isSubmitted=true&id=' + this.$route.query.id)
        } else {
          this.$router.push('/technologyList?id=' + this.$route.query.id)
        }
      }
    },

    downloadFile (row) {
      window.open(downloadUrl + row.file_path, '_blank')
    },

    delFile (row) {
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          id: row.id
        }
        API.delFileInfo(params).then(resp => {
          if (resp.resultCode === '0000') {
            this.$message.success('删除成功')
            this.asyncGetFileList()
          }
        })
      })
    },

    handleSizeChange (pageSize) {
      this.pageSize = pageSize
      this.asyncGetFileList()
    },

    handleCurrentChange (currentPage) {
      this.currentPage = currentPage
      this.asyncGetFileList()
    }
  }
}
</script>

<style lang="scss">
.energyMain  {
  .selectFile {
    margin: 0 20px;
  }
  .fileAbout {
    margin-bottom: 15px;
    .fileName {
      margin-right: 20px;
    }
  }
}
</style>
